import { Loader2 } from 'lucide-react';

export function LoadingFallback() {
  return (
    <div
      className="flex min-h-svh items-center justify-center bg-white"
      role="status"
      aria-label="Loading"
    >
      <Loader2 className="size-8 animate-spin text-brand-600" aria-hidden="true" />
    </div>
  );
}